import { ToolType } from "./ToolTypes";

export class Tool {
  private id: string;
  private name: string;
  private type: ToolType;
  private description: string;
  private icon?: string;
  private iconColor?: string;
  private rawData: any;
  /** Display name: tool name only (e.g. erp.search-units). Used for palette label. */
  private displayName: string;
  /** Provider name (e.g. server or marketplace offer name). Shown in tooltip for MCP tools. */
  private providerName: string | undefined;

  constructor(tool: any) {
    // Store the raw data first
    this.rawData = tool;

    const marketplaceOffer = tool._marketplaceOffer || tool.marketplaceOffer;
    const hasMarketplaceOffer = Boolean(marketplaceOffer);

    if (hasMarketplaceOffer) {
      // Map server type to enum
      switch (tool.type) {
        case "mcpTool":
          this.type = ToolType.MCP_TOOL;

          // For MCP tools, use the tool ID as display name (e.g. erp.site.create).
          // Extract from ID after first slash, or use full ID if no slash.
          const toolId = tool._id || tool.id;
          let toolNameFromId = "Unknown Tool";
          if (toolId) {
            toolNameFromId = toolId.includes("/")
              ? toolId.split("/").slice(1).join("/")
              : toolId;
          }

          this.id = toolId;
          this.displayName = toolNameFromId;
          this.providerName = marketplaceOffer.name;
          this.name = toolNameFromId;
          break;
        case "knowledgeBase":
          this.type = ToolType.KNOWLEDGE_BASE;
          this.id = tool._id || tool.id;
          this.name = marketplaceOffer.name;
          this.displayName = marketplaceOffer.name;
          this.providerName = undefined;
          break;
        case "promptTool":
          this.type = ToolType.PROMPT_TOOL;
          this.id = tool._id || tool.id;
          this.name = marketplaceOffer.name;
          this.displayName = marketplaceOffer.name;
          this.providerName = undefined;
          break;
        case "agenticWorkflow":
          this.type = ToolType.AGENTIC_WORKFLOW;
          this.id = tool._id || tool.id;
          this.name = marketplaceOffer.name;
          this.displayName = marketplaceOffer.name;
          this.providerName = undefined;
          break;
        default:
          throw new Error(
            `Invalid tool type ${tool.type} with marketplace offer.`
          );
      }

      // Set description based on tool type
      if (tool.type === "mcpTool") {
        this.description = tool.description;
      } else {
        this.description = marketplaceOffer.description;
      }

      const originalIcon = marketplaceOffer.icon;
      this.icon =
        originalIcon?.toLowerCase() === "building"
          ? "CityNext"
          : originalIcon || "CityNext";

      this.iconColor = marketplaceOffer.iconColor || "#8764b8";
    } else if (tool.type === "mcpTool") {
      this.type = ToolType.MCP_TOOL;

      const toolId = tool._id || tool.id;
      let toolNameFromId = "Unknown Tool";
      if (toolId) {
        toolNameFromId = toolId.includes("/")
          ? toolId.split("/").slice(1).join("/")
          : toolId;
      }

      const serverName = tool.serverName || tool.provider?.name;

      this.id = toolId;
      this.displayName = toolNameFromId;
      this.providerName = serverName;
      this.name = toolNameFromId;
      this.description = tool.description || "";
      this.icon = tool.icon || "PlugConnected";
      this.iconColor = tool.iconColor || "#8764b8";
    } else {
      throw new Error(`Invalid tool type ${tool.type}.`);
    }

    console.log("🔍 Tool:", this);
  }

  /** Returns the tool name for display (e.g. erp.search-units). */
  getDisplayName(): string {
    return this.displayName;
  }

  /** Returns the provider name for MCP tools, or undefined for other types. */
  getProviderName(): string | undefined {
    return this.providerName;
  }

  getName(): string {
    return this.name;
  }

  getType(): ToolType {
    return this.type;
  }

  getTypeName(): string {
    switch (this.type) {
      case ToolType.AGENTIC_WORKFLOW:
        return "Workflow";
      case ToolType.MCP_TOOL:
        return "MCP-Werkzeug";
      case ToolType.KNOWLEDGE_BASE:
        return "Wissensbasis";
      case ToolType.PROMPT_TOOL:
        return "Prompt-Werkzeug";
      default:
        return "Unbekanntes Werkzeug";
    }
  }

  getDescription(): string {
    return this.description;
  }

  getId(): string {
    return this.id;
  }

  getIcon(): string | undefined {
    return this.icon;
  }

  getIconColor(): string | undefined {
    return this.iconColor;
  }

  getRawData(): any {
    return this.rawData;
  }
}
